import { DollarSign, ShoppingBag, UserCheck, FileText, ClipboardCheck, Contact, ShieldAlert, MessageCircle, Store, UserPlus, UtensilsCrossed } from "lucide-react";
import { useResource, money, HubRow, StatTile } from "./Shared";

export default function TodayTab({ go }) {
  const { data, loading } = useResource("today");
  if (loading || !data) return <p className="py-16 text-center text-sm text-charcoal/40">Loading…</p>;

  const attention = [
    { icon: UserCheck, label: "Creator approvals waiting", count: data.pending_creator_approvals, tab: "creators", screen: "pipeline", testId: "attn-creator-approvals" },
    { icon: FileText, label: "Documents to review", count: data.pending_documents, tab: "creators", screen: "pipeline", testId: "attn-documents" },
    { icon: ClipboardCheck, label: "Listings to review", count: data.pending_listings, tab: "creators", screen: "listings", testId: "attn-listings" },
    { icon: Contact, label: "Customer IDs to verify (18+)", count: data.pending_id_verifications, tab: "consumers", screen: "pipeline", testId: "attn-ids" },
    { icon: ShieldAlert, label: "Open complaints", count: data.open_complaints, tab: "consumers", screen: "complaints", testId: "attn-complaints" },
    { icon: MessageCircle, label: "Support chats waiting", count: data.open_support_chats, tab: "inbox", screen: "chats", testId: "attn-chats" },
  ];

  return (
    <div className="space-y-5" data-testid="today-tab">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="rounded-2xl border border-black/5 bg-white p-5" data-testid="today-revenue">
          <div className="flex items-center gap-2 text-charcoal/50">
            <DollarSign className="h-4 w-4" />
            <span className="text-[13px] font-semibold">Dishly revenue today</span>
          </div>
          <p className="mt-2 font-display text-4xl font-bold text-charcoal">{money(data.dishly_revenue_today)}</p>
          <p className="mt-1 text-[13px] text-charcoal/55">{data.orders_today} today · {money(data.gmv_today)} customer spend</p>
        </div>
        <div className="rounded-2xl border border-black/5 bg-white p-5" data-testid="today-orders">
          <div className="flex items-center gap-2 text-charcoal/50">
            <ShoppingBag className="h-4 w-4" />
            <span className="text-[13px] font-semibold">Orders today</span>
          </div>
          <p className="mt-2 font-display text-4xl font-bold text-charcoal">{data.orders_today}</p>
          <p className="mt-1 text-[13px] text-charcoal/55">{data.active_orders} active right now</p>
        </div>
      </div>

      <div>
        <h3 className="mb-2.5 text-xs font-bold uppercase tracking-widest text-charcoal/40">Needs your attention</h3>
        <div className="space-y-2.5">
          {attention.map((a) => (
            <HubRow key={a.label} icon={a.icon} title={a.label} badge={a.count} testId={a.testId}
              onClick={() => go(a.tab, a.screen)} />
          ))}
        </div>
      </div>

      <div>
        <h3 className="mb-2.5 text-xs font-bold uppercase tracking-widest text-charcoal/40">Live on Dishly</h3>
        <HubRow icon={Store} title="Approved kitchens" subtitle="Creators live and selling right now" badge={data.approved_kitchens} testId="today-approved-kitchens"
          onClick={() => go("creators", "all")} />
      </div>

      <div>
        <h3 className="mb-2.5 text-xs font-bold uppercase tracking-widest text-charcoal/40">New today</h3>
        <div className="grid grid-cols-3 gap-3">
          <StatTile n={data.new_creators_today} label="Creator signups" testId="today-new-creators" onClick={() => go("creators", "pipeline")} />
          <StatTile n={data.new_customers_today} label="New customers" testId="today-new-customers" onClick={() => go("consumers", "pipeline")} />
          <StatTile n={data.listings_approved_today} label="Listings approved" testId="today-listings-approved" onClick={() => go("creators", "listings")} />
        </div>
      </div>
    </div>
  );
}
